import { render, staticRenderFns } from "./ImagePoster.vue?vue&type=template&id=12007f28&scoped=true&"
import script from "./ImagePoster.vue?vue&type=script&lang=js&"
export * from "./ImagePoster.vue?vue&type=script&lang=js&"
import style0 from "./ImagePoster.vue?vue&type=style&index=0&id=12007f28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12007f28",
  null
  
)

export default component.exports